import { useCallback, useEffect, useState } from 'react';

import throttle from 'lodash/throttle';

const headerMenuHeight = 80;
const progressBarCorrectionCoefficient = 1.05;

const useScrollPosition = () => {
  const [element, setElement] = useState<Element | null>(null);
  const [isInterceptedAtTop, setIsInterceptedAtTop] = useState(false);
  const [progress, setProgress] = useState(0);

  const updateScroll = useCallback(() => {
    if (!element) return;

    const { top: topPosition, height } = element.getBoundingClientRect();

    setIsInterceptedAtTop(topPosition <= headerMenuHeight);

    const newProgress = (100 - ((height + topPosition) / height) * 100) * progressBarCorrectionCoefficient;

    setProgress(newProgress);
  }, [element]);

  useEffect(() => {
    const throttledScroll = throttle(updateScroll, 100);

    document.addEventListener('scroll', throttledScroll, { passive: true });

    return () => {
      document.removeEventListener('scroll', throttledScroll);
    };
  }, [updateScroll]);

  return { setElement, isInterceptedAtTop, progress };
};

export default useScrollPosition;
